import { ref } from 'vue'
import { defineStore } from 'pinia'
import { useConfigStore } from '@/stores/config'
import { useRequestsStore } from '@/stores/requests'
import { useTokenStore } from '@/stores/token'

export const useEcusFirmwareStore = defineStore('ecus-firmware', () => {

    const configStore   = useConfigStore()
    const requestsStore = useRequestsStore()
    const tokenStore    = useTokenStore()

    const firmwares = ref({})
    const firmwaresProcess = ref(false)
    const firmwaresMsg = ref({})

    const firmwareCreateProcess = ref(false)
    const firmwareCreateMsg = ref({})

    const firmwareDeleteProcess = ref(false)
    const firmwareDeleteMsg = ref({})

    /**
     * Создаёт новый файл прошивки
     * 
     * @param {Object} payload - file: объект с полями формы создания нового файла прошивки, vin: VIN-код автомобиля
     */
    async function createFirmware(payload) {

        firmwareCreateProcess.value = true
        const token = tokenStore.access

        if(token) {

            const request = await requestsStore.fetchRequest({
                address: `${configStore.httpServer}/devices/firmware`, 
                method: 'POST', 
                token,
                type: 'file',
                data: payload.data
            })

            if(!request.error) {
                firmwareCreateMsg.value = { success: true, text: 'ECU_FIRMWARE_CREATE_SUCCESS' }
            } else {
                firmwareCreateMsg.value = { success: false, text: request.error }
            }

        } else {
            firmwareCreateMsg.value = { success: false, text: 'EUnauthRequest' }
        }

        firmwareCreateProcess.value = false
    }

    /**
     * Получает автомобили
     * 
     * @param {String} payload - параметры запроса [см.swagger]
     */
    async function readFirmwares(payload) {

        firmwaresProcess.value = true
        const token = tokenStore.access

        if(token) {

            let params = ''

            if(payload) {
                for( let param in payload) {
                    params.length ?
                        params += '&' + param + '=' + payload[param] :
                        params = '?' + param + '=' + payload[param]
                }
            }

            const request = await requestsStore.fetchRequest({
                address: `${configStore.httpServer}/devices/firmware${params}`, 
                method: 'GET', 
                token
            })

            if(!request.error) {
                firmwares.value = request
                firmwaresMsg.value = { success: true }
            } else {
                firmwares.value = {}
                firmwaresMsg.value = { success: false, text: request.error }
            }

        } else {
            firmwaresMsg.value = { success: false, text: 'EUnauthRequest' }
        }

        firmwaresProcess.value = false
    }

    /**
     * Удаляет выбранную прошивку ЭБУ
     * 
     * @param {String} payload - { vin: "VIN-код автомобиля", name: "имя прошивки" }
     */
    async function deleteFirmware(payload) {

        firmwareDeleteProcess.value = true
        const token = tokenStore.access

        if(token) {

            const request = await requestsStore.fetchRequest({
                address: `${configStore.httpServer}/devices/firmware/${payload.uuid}/${payload.name}`, 
                method: 'DELETE', 
                token
            })

            if(!request.error) {
                firmwareDeleteMsg.value = { success: true, text: 'ECU_FIRMWARE_DELETE_SUCCESS' }
            } else {
                firmwareDeleteMsg.value = { success: false, text: request.error }
            }

        } else {

            firmwareDeleteMsg.value = { success: false, text: 'EUnauthRequest' }
        }

        firmwareDeleteProcess.value = true
    }

    const setCreateFirmwareMsg    = data => firmwareCreateMsg.value    = data
    const setFirmwaresMsg         = data => firmwaresMsg.value         = data
    const setDeleteFirmwareMsg    = data => firmwareDeleteMsg.value    = data

    const resetFirmware = () => {

        firmwares.value = {}
        firmwaresProcess.value = false
        firmwaresMsg.value = ''

        firmwareCreateProcess.value = false
        firmwareCreateMsg.value = ''

        firmwareDeleteProcess.value = false
        firmwareDeleteMsg.value = ''
    }

    return {

        firmwares,
        firmwaresProcess,
        firmwaresMsg,
        firmwareCreateProcess,
        firmwareCreateMsg,
        firmwareDeleteProcess,
        firmwareDeleteMsg,
        createFirmware,
        readFirmwares,
        deleteFirmware,
        setCreateFirmwareMsg,
        setFirmwaresMsg,
        setDeleteFirmwareMsg,
        resetFirmware
    }
})
